<app-page-header [headline]="headline()" />
<p>{{ description() }}</p>
<app-contract-list
    [route]="route()"
    [contracts]="contracts()"
></app-contract-list>
